import {
  DatePicker as AntDatePicker,
  DatePickerProps,
  TimeRangePickerProps,
} from "antd";

import styles from "./date-picket.module.scss";

import locale from "antd/es/date-picker/locale/vi_VN";
import "moment/locale/vi";

import { DateFormat } from "../../../constants";

const { RangePicker: AntRangePicker } = AntDatePicker;

type Props = DatePickerProps;
type RangePickerProps = TimeRangePickerProps & { showTime?: any };

export const DatePicker = (props: Props) => {
  return (
    <AntDatePicker
      locale={locale}
      format={DateFormat.DD_MM_YYY}
      placeholder="Chọn ngày"
      {...props}
    />
  );
};

const RangePicker = (props: RangePickerProps) => {
  return (
    <AntRangePicker
      className={styles.rangePicker}
      locale={locale}
      format={[DateFormat.DD_MM_YYY, DateFormat.DD_MM_YYY]}
      placeholder={["Từ ngày", "Đến ngày"]}
      {...props}
    />
  );
};

DatePicker.RangePicker = RangePicker;
